import { Info } from "lucide-react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useRiderStocks } from "@/hooks/use-rider-stocks";

import type { StockItem } from "./types";

/** Rider-held qty of a product; clickable popover listing which riders carry it. */
export function StockRiderQtyCell({ item }: { item: StockItem }) {
  const { data: riderStocks = [] } = useRiderStocks();

  if (item.type !== "product") {
    return <span className="text-muted-foreground">-</span>;
  }

  const holders = riderStocks
    .map((r) => ({
      riderId: r.riderId,
      riderName: r.riderName,
      qty: r.items.find((it) => it.productId === item.itemId)?.qty ?? 0,
    }))
    .filter((r) => r.qty !== 0);

  if (holders.length === 0 || item.riderQty === 0) {
    return (
      <span
        className={
          item.riderQty < 0
            ? "font-mono font-medium text-destructive"
            : "text-muted-foreground"
        }
      >
        {item.riderQty.toLocaleString("id-ID")}
      </span>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center gap-1 font-mono text-xs font-medium underline underline-offset-2 cursor-pointer ${
            item.riderQty < 0
              ? "text-destructive hover:text-destructive/80"
              : "text-primary hover:text-primary/80"
          }`}
          title="Klik untuk melihat rider yang membawa produk ini"
        >
          <span>{item.riderQty.toLocaleString("id-ID")}</span>
          <Info className="h-3 w-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2.5 text-xs" align="end">
        <p className="font-semibold text-foreground mb-1.5 border-b pb-1 text-xs">
          Rider Pembawa Produk
        </p>
        <div className="space-y-1">
          {holders.map((r) => (
            <div
              key={r.riderId}
              className="flex items-center justify-between text-muted-foreground"
            >
              <span className="truncate pr-2">{r.riderName}</span>
              <span
                className={`font-mono font-medium ${
                  r.qty < 0 ? "text-destructive" : "text-foreground"
                }`}
              >
                {r.qty} unit
              </span>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
